<template>
  <div class="">
    <div class="header">
      <p class="is-title" v-text="fieldsConfig.title" />
      <p v-text="fieldsConfig.text" />
    </div>

    <template
      v-if="!isSubmitted"
    >
      <v-field
        v-model="email"
        is-full-width
        placeholder="Эл. почта"
      />

      <v-button
        text="Отправить"
        color="blue"
        fluid
        size="md"
        :disabled="!email"
        @click="sendEmail"
      />

      <div class="login-form__links">
        <span
          class="link"
          @click="$emit('cancel')"
        >
          Вернуться назад
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import VField from "./VField";
import VButton from "./VButton";


export default {
  name: "RecoveryPassword",

  components: {
    VField,
    VButton
  },

  data() {
    return {
      email: "",
      isSubmitted: false
    };
  },

  computed: {
    fieldsConfig() {
      return this.isSubmitted
        ? {
            title: "Письмо отправлено",
            text:
              "Вам на почту будет отправлено письмо с ссылкой для восстановления"
          }
        : {
            title: "Сброс пароля",
            text:
              "Укажите адрес, на который будет отправлена ссылка для восстановления пароля"
          };
    }
  },

  methods: {
    async sendEmail() {
      await this.$store.dispatch("authorization/sendRecoverLetter", this.email);
      this.isSubmitted = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
